import { SubContentTypeCreate } from "./subContentTypeCreate";
import { SubContentTypeEdit } from "./subContentTypeEdit";
import { SubContentTypeList } from "./subContentTypeList";

export default {
	create: SubContentTypeCreate,
	edit: SubContentTypeEdit,
	list: SubContentTypeList,
};
